/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Delete_Account_WarningInputs */

const en_mobile_delete_account_warning = /** @type {(inputs: Mobile_Delete_Account_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone and you will lose access to all the files you listened to with Listening.`)
};

const es_mobile_delete_account_warning = /** @type {(inputs: Mobile_Delete_Account_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta acción no se puede deshacer y perderás acceso a todos los archivos que escuchaste con Listening.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone and you will lose access to all the files you listened to with Listening." |
*
* @param {Mobile_Delete_Account_WarningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_delete_account_warning = /** @type {((inputs?: Mobile_Delete_Account_WarningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Delete_Account_WarningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_delete_account_warning(inputs)
	return en_mobile_delete_account_warning(inputs)
});